import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import { createClient } from '@supabase/supabase-js';
import Login from './components/Login';
import Map from './components/Map';
import Navbar from './components/Navbar';
import './App.css';
import dayjs from 'dayjs';

const supabase = createClient(
  process.env.REACT_APP_SUPABASE_URL,
  process.env.REACT_APP_SUPABASE_ANON_KEY
);

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
});

function App() {
  const [isAuthenticated, setIsAuthenticated] = React.useState(false);

  // Calculate last 30 days date range
  const now = dayjs();
  const startOfRange = now.subtract(29, 'day').startOf('day');
  const endOfRange = now.endOf('day');
  const dateRangeString = `${startOfRange.format('MMM D, YYYY')} - ${endOfRange.format('MMM D, YYYY')}`;

  React.useEffect(() => {
    // Check if user is authenticated using Supabase
    const checkAuth = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      setIsAuthenticated(!!session);
    };

    checkAuth();

    // Set up auth state change listener
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setIsAuthenticated(!!session);
    });

    return () => {
      subscription?.unsubscribe();
    };
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <div className="App">
          <Navbar isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated} dateRange={dateRangeString} />
          <div style={{ 
            height: 'calc(100vh - 64px)', // Subtract navbar height
            width: '100%',
            position: 'relative',
            overflow: 'hidden'
          }}>
            <Routes>
              <Route 
                path="/" 
                element={isAuthenticated ? <Map /> : <Navigate to="/login" />} 
              />
              <Route 
                path="/login" 
                element={!isAuthenticated ? <Login setIsAuthenticated={setIsAuthenticated} /> : <Navigate to="/" />} 
              />
            </Routes>
          </div>
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;
